<template>
	<div v-if="event">
		<v-dialog :fullscreen="isMobile" attach v-model="open" max-width="700px" scrollable>
			<v-card height="50vh;" v-if="getPaymentModalEvent && paymentToken">
				<v-card-title class="modal__title">
					<button class="btn-flat-icon--dark" type="button" @click="open=false">
						<v-icon medium>fal fa-times</v-icon>
					</button>
					<v-spacer></v-spacer>
					<v-icon small style="color: #AAA;">fas fa-lock</v-icon>
					<span class="braintree-secure--text">
						<a href="https://www.braintreegateway.com/merchants/n7kq32c2r76sww2q/verified" target="_blank">Braintree</a> Verified Secure <br>
						256 bit SSL encryption
					</span>
				</v-card-title>
				<v-card-text class="modal__card-text basic-modal-padding">
					<div>
						<v-layout row wrap>
							<v-flex xs12>
								<div class="payment-modal__header mt-3">Confirm Payment</div>
								<div class="payment-modal__subheader">Your <strong>all-inclusive</strong> ${{ getPrice.toFixed(2) }} ticket includes all event activities, amenities, beverages &amp; snacks.</div>
								<div class="payment-modal__subheader mt-3" v-if="getModalProp('paymentModalAddons')">Your ticket also includes ${{event.addons[0].price}} {{event.addons[0].title}} {{event.addons[0].time_slot}} the event from {{event.addons[0].start_time}} to {{event.addons[0].end_time}}</div>
								<p v-if="requiresApproval" class="payment-modal__subheader error--text mt-3 mb-3">You must be approved by the host before attending this event. Your card will be charged <strong>after</strong> you are approved.</p>
								<p v-else class="payment-modal__subheader mt-3 mb-3"><i>Your card will be charged ${{ getPrice.toFixed(2) }}.</i></p>
								<div class="mb-3">

									<p class="payment-modal__small mb-0">*Pro tip: Use your business card to track WRKPRTY as an expense.</p>
									<!-- <v-select
										:items="paymentMethodOptions"
										v-model="selectedPaymentMethod"
										placeholder="Select Payment Method"
										hide-details
										single-line
										bottom
										item-text="text"
										item-value="value"
										class="mb-2"
									></v-select> -->
									<div class="mt-4 mb-3" v-if="paymentMethodOptions.length > 1">
										<v-layout row wrap>
											<v-flex xs1>
												<i style="font-size: 2.2em; display: inline;" class="fal fa-credit-card"></i>&nbsp;&nbsp;&nbsp;&nbsp;
											</v-flex>
											<v-flex xs8 class="pl-2">
												<span class="payment-modal__method-header mb-0">Payment method: </span><br>
												<span style="font-size: 0.8em; font-weight: normal;">
													<span v-if="selectedPaymentMethod === 'new'">Adding new payment method</span>
													<span v-else>{{getPaymentMethod}}</span>
												</span>
											</v-flex>
											<v-flex xs3 class="text-xs-right">
												<v-menu left class="text-xs-center">
													<v-btn slot="activator" flat class="info--text">Change</v-btn>
													<v-list>
														<v-list-tile v-for="item in paymentMethodOptions" :key="item.value" @click="selectedPaymentMethod = item.value">
															<span style="color: #666">{{ item.text }}</span>
														</v-list-tile>
													</v-list>
												</v-menu>
											</v-flex>
										</v-layout>
									</div>
									<!-- <v-layout column align-center justify-center v-else-if="selectedPaymentMethod === null" style="width: 100%; height: 250px;">
										<p>Loading</p>
										<i class="fal fa-spinner rotation success--text" style="font-size: 5.0em;"></i>
									</v-layout> -->

									<hosted-fields
										v-show="showHostedFields"
										wrapperClass="constrain2222"
										:authToken="paymentToken"
										:tokenize="tokenize"
										v-on:bthferror="btHFError"
										v-on:bthfpayload="btHFPayload"
										v-on:tokenized="tokenized"
										:collectCardHolderName="false"
										:collectPostalCode="false"
										:enableDataCollector="false"
									></hosted-fields>
									<a class="info--text mb-3" @click="openPromo = !openPromo">Have a promo code?</a>
									<div v-show="openPromo" :style="getPromoBoxStyle" class="pa-2 mt-2">
										<v-text-field
											style="flex-grow: 2;"
											@input="promoValid=false"
											label="Promo Code"
											placeholder="Enter Code"
											:disabled="promoValid && promoChecked"
											v-model="promoCode"
											:append-icon="promoChecked ? (promoValid ? 'fas fa-check-circle' : 'fas fa-times-circle') : ''"
											:error-messages="promoErrorMessage"
										></v-text-field>
										<v-btn
											class="mb-0 info ml-3"
											flat
											:style="getPromoButtonStyle"
											:disabled="promoChecking"
											:loading="promoChecking"
											v-if="!promoValid || !promoChecked"
											@click="checkPromoValid"
										>
											Apply Promo Code
										</v-btn>
										<div v-else style="width: 100%;" class="text-xs-center">
											<p style="font-weight: bold; color: #777">Your promo price is ${{ this.promoPrice.toFixed(2) }}!</p>
										</div>
									</div>
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div>
						<div class="text-xs-center">
							<!-- <v-layout v-if="submitStarted" column align-center justify-center style="width: 100%; height: 300px;">
								<p class="mt-3 mb-1">Submitting</p>
								<i class="fal fa-spinner rotation success--text" style="font-size: 5.0em;"></i>
							</v-layout> -->
							<v-btn block class="btn-orange white--text btn-xlarge" :loading="submitStarted || selectedPaymentMethod === null" :disabled="disableSubmitButton" @click="checkout"><span v-if="requiresApproval">Submit for Approval</span><span v-else>Submit Payment</span></v-btn>
							<p class="payment-modal__small mt-3 text-xs-center">By submitting payment you agree to our <a @click="openPaymentTerms">Payment Terms</a></p>
						</div>
						<!-- <v-btn v-else block dark class="success btn-xlarge" :disabled="braintreeError" @click="addPaymentMethod">Add Payment Method</v-btn> -->
						<img v-if="!isMobile" class="event-page-flat-logo" src="/static/images/wrkprty-flattened-logo.png" alt="">
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import Raven from 'raven-js'
import { mapGetters, mapActions } from 'vuex'
import PaymentForm from '~/components/payment/PaymentForm'
import axios from 'axios'
import btClient from 'braintree-web/client'
import btVault from 'braintree-web/vault-manager'
import HostedFields from '~/components/payment/HostedFields.vue'
// import btDropin from 'braintree-web-drop-in'
import { segmentIdentify, segmentTrack } from '~/plugins/segment'
import { deepCopy } from '~/store/util/util'

export default {
	data() {
		return {
			promoChecking: false,
			promoChecked: false,
			openPromo: false,
			dialog: false,
			paymentToken: null,
			dropinOptions: {
				authorization: null,
				selector: '#dropin-container'
			},
			promoCode: "",
			promoValid: true,
			promoPrice: 0,
			promoError: false,
			promoErrorMessage: [],
			errorMessage: '',
			dropinInstance: '',
			paymentPayload: '',
			dataCollectorPayload: '',
			wrapperClass: 'constrain',
			collectCardHolderName: true,
			enableDataCollector: true,
			enablePayPal: true,
			paymentMethodNonce: null,
			startingPremium: false,
			submitStarted: false,
			braintreeError: false,
			loadingBraintree: true,
			enteringNewPaymentMethod: false,
			paymentMethods: [],
			selectedPaymentMethod: null,
			tokenize: false,
			paymentTokenCount: 1,
		}
	},
	beforeRouteLeave(to, from, next) {
		this.resetPromoCode()
		next()
	},
	created() {
		this.getPaymentToken()
	},
	watch: {
		paymentToken(newValue, oldValue) {
			if (newValue !== null) {
				this.dropinOptions.authorization = newValue
			}
		}
	},
	methods: {
		...mapActions([
			'setEventRSVPSuccessModalEvent',
			'setUserProp',
			'setEventProp',
			'setAllEvents',
			'setGenericModalTitle',
			'setGenericModalText',
			'setTermsPage',
			'setModalOpen',
			'setModalProp',
			'openRSVPSuccessModal'
		]),
		getPaymentToken() {
			if (this.userIsAuthenticated) {
			axios
				.get('/api/v1/payment-token/')
				.then(response => {
					this.paymentToken = response.data
				})
				.catch(error => {
					this.paymentTokenCount += 1
					console.error('Error receiving payment token')
					console.error(error)
					Raven.captureMessage(error, {
						level: 'error'
					});
					if (this.paymentTokenCount > 3) {
						location.reload();
					} else {
						setTimeout(() => {
							this.getPaymentToken()
						}, 2000)
					}
				})
		}
		},
		checkPromoValid() {
			this.promoChecking = true
			this.promoValid = false
			if (this.promoCode === null || this.promoCode === '') {
				this.promoChecking = false
				this.promoErrorMessage = ['Please enter a promo code']
				this.promoChecked = true
				return
			}
			axios.post(`/api/v1/promo/verify/${this.promoCode}/`, {event: this.event.pk, location: this.event.location.pk})
				.then((response) => {
					this.promoChecking = false
					this.promoChecked = true
					this.promoValid = true
					this.promoPrice = response.data.price
					this.promoErrorMessage = []
				})
				.catch((error) => {
					// Reset promo code values
					this.resetPromoCode()
					this.promoError = true
					this.promoErrorMessage = [error.response.data]
					console.error(error)
				})
		},
		openPaymentTerms() {
			this.setTermsPage('paymentpolicy')
			this.setModalOpen({ prop: 'termsModal', value: true })
		},
		tokenized() {
			this.tokenize = false
		},
		checkout() {
			if (this.selectedPaymentMethod === 'new') {
				this.tokenize = true
			} else {
				this.submitPayment()
			}
		},
		submitPayment() {
			if (!this.selectedPaymentMethod || this.selectedPaymentMethod === 'new') {
				console.log('No payment nonce')
				this.errorMessage =
					'Error submitting payment.  Please select a payment method and try again.'
			} else {
				this.submitStarted = true
				let buyAddon = false
				if (this.getModalProp('paymentModalAddons') !== null) {
					buyAddon = true
				}
				axios.post('/api/v1/event/rsvp/', {
					buy_addon: buyAddon,
					event_id: this.event.pk,
					payment_method_nonce: this.selectedPaymentMethod,
					starting_premium: this.startingPremium,
					promo_code: this.promoCode
				})
				.then((response) => {
					// Reset promo code values
					this.resetPromoCode()
					this.submitStarted = false

					console.log('successful payment')
					console.log(response)

					this.setEventProp({
						prop: 'attendees',
						value: response.data.event.attendees
					})

					this.event.final_price = response.data.charge_amount

					this.setEventProp({
						prop: 'final_price',
						value: response.data.charge_amount
					})
					
					segmentTrack('RSVP', {
						event_name: this.event.title,
						event_id: this.event.pk,
						price: this.getPrice
					})
					if (this.startingPremium) {
						this.setUserProp({ is_premium: true })
						segmentTrack('Became Premium', {
							description: 'Bought event ticket and got premium',
							event_name: this.event.title,
							event_id: this.event.pk,
							price: this.getPrice
						})
					}
					this.openRSVPSuccessModal()
					this.setModalProp({
						prop: 'eventRSVPSuccessModalAddons',
						value: deepCopy(this.getModalProp('paymentModalAddons'))
					})
					// this.setModalOpen({prop: 'eventRSVPSuccessModal', value: true})
					this.setEventRSVPSuccessModalEvent(this.event)
					this.setModalProp({ prop: 'paymentModalAddons', value: null })
				})
				.catch(error => {
					// Reset promo code values
					this.resetPromoCode()
					this.submitStarted = false
					this.setModalOpen({ prop: 'genericModal', value: true })
					this.setGenericModalTitle('Error')
					this.setGenericModalText([
						error.response.data,
						'Payment failed.',
					])
					console.log(error)
					console.log(error.response)
				})
			}
		},
		resetPromoCode() {
			// Reset promo code values
			this.promoChecking = false
			this.promoChecked = false
			this.promoCode = ""
			this.promoValid = false
			this.promoPrice = 0
			this.promoError = false
			this.promoErrorMessage = []
		},
		btHFError(message) {
			console.error(message)
			// do something with the error message
		},
		btHFPayload(payload) {
			// console.log(payload)
			this.paymentMethods.push(payload)
			this.selectedPaymentMethod = payload.nonce
			this.submitPayment()
		},
		addPaymentMethod() {
			console.log('addPaymentMethod')
			this.tokenize = true
		},
		createBraintreeVault(token) {
			btClient.create({ authorization: token }, (err, client) => {
				if (err) {
					Raven.captureMessage(err, {
						level: 'error' // one of 'info', 'warning', or 'error'
					});
					console.error(err)
					return
				}
				btVault.create(
					{
						client: client
					},
					(err, vm) => {
						if (err) {
							Raven.captureMessage(err, {
								level: 'error' // one of 'info', 'warning', or 'error'
							});
							console.error(err)
							return
						}

						vm.fetchPaymentMethods((err, paymentMethods) => {
							if (err) {
								Raven.captureMessage(err, {
									level: 'error' // one of 'info', 'warning', or 'error'
								});
								console.error(err)
								return
							}
							// An array of payment methods
							if (paymentMethods.length > 0) {
								this.paymentMethods = paymentMethods
								this.selectedPaymentMethod = paymentMethods[0].nonce
							} else {
								this.selectedPaymentMethod = 'new'
							}
						})
					}
				)
			})
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getAllEvents',
			'getModalProp',
			'getPaymentModalEvent',
			'getPaymentModalStatus',
			'userIsAuthenticated'
		]),
		getPromoButtonStyle() {
			let style = {
				'height': '45px',
				'border-radius': '5px'
			}

			if (this.isMobile) {
				style['margin'] = '0px!important'
				style['width'] = '100%!important'
			}

			return style
		},
		getPromoBoxStyle() {
			let style = {
				'display': 'flex',
				'flex-flow': 'row wrap',
				'border': '1px solid #74cbf1',
				'box-shadow': '0px 0px 5px #74cbf1'
			}
			if (this.isMobile) {
				style['display'] = 'block'
			}
			if (this.promoValid === false && this.promoChecked === true) {
				style['box-shadow'] = '0px 0px 5px #de6455'
				style['border'] = '1px solid #de6455'
			}

			return style
		},
		requiresApproval() {
			if (this.event.restrictions.approval === 'all_need_approval') {
				return true
			}
			if (this.event.restrictions.approval === 'level_one') {
				if (this.user.past_events) {
					if (this.user.past_events.length === 0) {
						return true
					}
				}
			}
		},
		getPrice() {
			let price = 0.0
			if (this.getModalProp('paymentModalAddons') !== null) {
				if (this.getModalProp('paymentModalAddons').length > 0) {
					price += parseFloat(this.getModalProp('paymentModalAddons')[0].price)
				}
			}
			if (!this.freePass) {
				price += this.event.price
			}
			if (this.promoValid && this.promoCode) {
				price = this.promoPrice
			}
			return price
		},
		freePass() {
			if (this.event) {
				if (this.user.free_pass) {
					if (this.event.location.free_pass_allowed) {
						return true
					}
				}
			}
			return false
		},
		paymentMethodOptions() {
			console.log(this.paymentMethods)
			let results = this.paymentMethods.map(obj => {
				return {
					text: 'Saved ' + obj.details.cardType + ' ' + obj.description,
					value: obj.nonce
				}
			})
			results = results.concat({ text: 'New Payment Method', value: 'new' })
			return results
		},
		getPaymentMethod() {
			return this.paymentMethodOptions.find(obj => {
				return obj.value === this.selectedPaymentMethod
			}).text
		},
		fieldsInvalid() {
			return false
		},
		showHostedFields() {
			if (this.selectedPaymentMethod === 'new') {
				return true
			}
			return false
		},
		disableSubmitButton() {
			if (this.selectedPaymentMethod === null) {
				return true
			}
			if (this.submitStarted) {
				return true
			}
		},
		event() {
			return this.getPaymentModalEvent
			// return this.getAllEvents.find(
			// 	obj => String(obj.slug) === String(this.$route.params.slug)
			// )
		},
		open: {
			get() {
				if (this.getModalProp('paymentModal') === true) {
					segmentTrack('Click RSVP', {
						event_name: this.event.title,
						event_id: this.event.pk
					})
					this.createBraintreeVault(this.paymentToken)
				}
				return this.getModalProp('paymentModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'paymentModal', value: val })
				if (val === false) {
					this.setModalProp({ prop: 'paymentModalAddons', value: null })
				}
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	},
	components: {
		PaymentForm,
		HostedFields
	}
}
</script>

<style lang="scss">
@-webkit-keyframes rotation {
	from {
		-webkit-transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(359deg);
	}
}
.rotation {
	-webkit-animation: rotation 2s infinite linear;
}
.padding {
	padding: 24px;
}
.payment-modal {
	color: #444;
	&__header {
		font-size: 2em;
		margin-bottom: 15px;
	}
	&__subheader {
		color: #666;
		font-size: 1.2em;
	}
	&__small {
		color: #999;
		font-size: 0.9em;
	}
}

.payment-modal__method-header {
	font-size: 1em;
	font-weight: bold;
}

.braintree-secure--text {
	margin-left: 10px;
	color: #aaa;
	font-size: 0.6em;
}

.payment-method-change-button {
	width: 60px !important;
	min-width: 60px !important;
	margin: 0 10px 0 10px !important;
	padding: 0 !important;
}

@media screen and (max-width: 600px) {
	.padding {
		padding: 10px;
	}
	.payment-modal {
		&__header {
			font-size: 1.75em;
			margin-bottom: 10px;
		}
		&__subheader {
			font-size: 0.9em;
		}
		&__small {
			font-size: 0.8em;
		}
	}
	.payment-modal__method-header {
		font-size: 0.9em;
	}
}
</style>
